import {useCountDown} from 'ahooks'
import {useEffect, useState} from "react";
import {styled, Button, Typography} from "@mui/material";
import dayjs from "dayjs";

interface Props {
  seconds: number;
  reSend?: () => void,
  onEnd?: () => void,
}

const Content = styled('span')(({theme}) => {
  return {
    color: '#E11D5C',
    fontSize: 16
  }
});

export default (props: Props) => {
  const {seconds, onEnd, reSend} = props
  const [target, setTarget] = useState(dayjs())
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    setTarget(dayjs().add(seconds, 'second'))
  }, [seconds]);

  const [countdown] = useCountDown({
    targetDate: target,
    interval: 1000,
    onEnd: () => {
      onEnd && onEnd();
      setIsEnd(true)
    }
  });

  return (
    <>
      {isEnd ? <Button
          sx={{'&:hover': {backgroundColor: 'transparent'}}}
          disableRipple variant="text" color="error" disabled={countdown !== 0} onClick={() => {
          setIsEnd(false)
          reSend && reSend()
          setTarget(dayjs().add(5, 'second'))
        }}><Typography textTransform="lowercase">send</Typography></Button> :
        <Typography color="error">
          {Math.round(countdown / 1000)} s
        </Typography>}
    </>

  );
};